<template>
  <v-app>
    <v-card class="bgss rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <!-- 步骤一 -->
      <div class="mx-auto box transition-fast-in-fast-out px-2 px-sm-8" flat v-if="tab == 1">
        <div class="step-header">
          <div class="step-titles">
            <p class="step-title">{{ $t("选择店铺类型") }}</p>
            <p class="step-sub">{{ $t("开通即拥有 AI 运营团队，7×24 小时自动管理你的跨境商店") }}</p>
          </div>
          <div class="step-num">
            <span class="step-current">1</span>
            <span class="step-total">/3</span>
          </div>
        </div>
        <div class="step-progress">
          <div class="step-progress-bar" style="width:33%"></div>
        </div>
          <v-col cols="12" class>
            <v-card width="100%" class="rounded-xl mt-4 px-5 py-6 py-md-12 px-md-10" color="#fff" flat>
              <v-row class="ma-0">
                <div>
                  <p class="mb-0 font24 font-weight-bold">{{ $t("在线商店") }}</p>
                  <p class="mt-1 text--secondary">
                    {{
                      $t(
                        "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业"
                    )
                    }}
                  </p>
                </div>
                <v-spacer />
                <!-- <v-card
                  class="d-flex align-center rounded-pill px-2"
                  height="63"
                  color="#F2F2F2"
                  flat
                >
                  <v-card
                    height="47"
                    style="line-height: 47px"
                    color="#F2F2F2"
                    flat
                    :class="
                      tab2Active.name == item.name
                        ? 'px-10 font18 primary rounded-pill white--text cursor'
                        : 'px-10 font18 rounded-pill cursor'
                    "
                    v-for="(item, index) in tab2Arr"
                    :key="index"
                    @click="tab2Active = item"
                  >
                    {{ item.name }}
                  </v-card>
                </v-card>-->
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-card min-height="302" color="#F7F7F7" class="px-7 py-11 rounded-xl" flat>
                    <v-img width="60" src="@/assets/images/login/icon1.png"></v-img>
                    <p class="my-5 font20 weight500">{{ $t("AI 员工代运营") }}</p>
                    <p class="mb-0 text--primary">
                      {{
                        $t(
                      "开通店铺即配备 AI 运营团队，自动上架商品、回复客户、处理订单，无需招人管理"
                      )
                      }}
                    </p>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-card min-height="302" color="#F7F7F7" class="px-7 py-11 rounded-xl" flat>
                    <v-img width="60" src="@/assets/images/login/icon2.png"></v-img>
                    <p class="my-5 font20 weight500">{{ $t("AI 跨境获客") }}</p>
                    <p class="mb-0 text--primary">
                      {{
                        $t(
                      "AI 自动生成多语言商品文案与营销素材，智能投放引流，帮你获取全球客户"
                      )
                      }}
                    </p>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-card min-height="302" color="#F7F7F7" class="px-7 py-11 rounded-xl" flat>
                    <v-img width="60" src="@/assets/images/login/icon3.png"></v-img>
                    <p class="my-5 font20 weight500">{{ $t("AI 智能客服") }}</p>
                    <p class="mb-0 text--primary">
                      {{
                        $t(
                      "AI 客服 7×24 小时多语言应答，自动处理售前售后，转化率显著提升"
                      )
                      }}
                    </p>
                  </v-card>
                </v-col>
              </v-row>
              <div class="step-sticky-bar" style="margin-top:24px;">
                <router-link to="/" class="step-action-btn">
                  <v-icon size="16" class="mr-1">mdi-logout-variant</v-icon>
                  {{ $t("离开") }}
                </router-link>
                <v-spacer />
                <v-btn color="#7331FF" dark rounded large @click="tab = 2">
                  {{ $t("下一步") }}
                  <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div class="mx-auto box transition-fast-in-fast-out" style="padding: 32px 0" flat v-if="tab == 2">
        <v-row class="my-0" align="center">
          <v-col cols="12" sm="5">
            <p class="font32 font-weight-bold mb-2">{{ $t("店铺模板") }}</p>
            <p class="mb-0 text-body-1 text--secondary">
              {{
                $t(
                  "上百种精选电商主题模板一键应用，卡片式操作，无需设计能力，快速拥有一个能提现您品牌调性、安全、稳定的在线商店"
              )
              }}
            </p>
          </v-col>
          <v-spacer />
          <v-col cols="12" sm="5" class="d-flex align-end justify-end">
            <p class="primary--text mb-0" style="font-size: 74px; font-weight: 900">2</p>
            <p class="primary--text mb-0" style="font-size: 44px; font-weight: 900">/3</p>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-card color="#fff" width="100%" height="16" class="rounded-pill" flat>
              <v-card width="66%" height="16" color="primary" flat class="rounded-r-0"></v-card>
            </v-card>
          </v-col>
          <v-col cols="12" class>
            <v-card width="100%" class="rounded-xl mt-4 px-3 py-6 py-md-12 px-md-10" color="#fff" flat>
              <p class="mb-0 font24 font-weight-bold">{{ $t("店铺模板") }}</p>
              <p class="mt-1 text--secondary">{{ $t("请选择您想要的模板~") }}</p>
              <!-- 模板筛选：开店要在上百套模板里挑，没有筛选只能一页页翻 -->
              <div class="tpl-filter">
                <div class="tpl-filter__cats">
                  <span class="tpl-cat" :class="{ active: !tplFilter.themes_tag_id }" @click="pickTplTag(null)">
                    {{ $t("全部") }}
                  </span>
                  <span class="tpl-cat" v-for="tag in tplTags" :key="tag.themes_tag_id"
                    :class="{ active: tplFilter.themes_tag_id == tag.themes_tag_id }" @click="pickTplTag(tag)">
                    {{ tag.name }}
                  </span>
                </div>
                <div class="tpl-filter__row">
                  <v-text-field v-model="tplFilter.keyword" dense outlined hide-details clearable
                    prepend-inner-icon="mdi-magnify" :placeholder="$t('搜索模板名称')" class="tpl-search"
                    @keyup.enter="applyTplFilter" @click:clear="applyTplFilter"></v-text-field>
                  <div class="tpl-price">
                    <v-text-field v-model="tplFilter.start_price" dense outlined hide-details type="number"
                      :placeholder="$t('最低价')" class="tpl-price__input"></v-text-field>
                    <span class="tpl-price__line">—</span>
                    <v-text-field v-model="tplFilter.end_price" dense outlined hide-details type="number"
                      :placeholder="$t('最高价')" class="tpl-price__input"></v-text-field>
                  </div>
                  <v-btn depressed color="#7331FF" dark height="40" class="tpl-filter__go" @click="applyTplFilter">
                    {{ $t("筛选") }}
                  </v-btn>
                  <span class="tpl-filter__reset" @click="resetTplFilter">{{ $t("重置") }}</span>
                  <span class="tpl-filter__count">{{ themesTotalCount }} {{ $t("个模板") }}</span>
                </div>
              </div>
              <v-card flat class="template-picker">
                <v-row>
                  <v-col cols="12" sm="6" md="4" v-for="(item, index) in themesList" :key="index">
                    <div class="tpl-card" :class="{ 'tpl-selected': check_moban.themes_id == item.themes_id }">
                      <v-img height="340" :src="item.cover_img == '' ? require('@/assets/images/login/cate.png') : item.cover_img" class="tpl-img">
                        <div class="tpl-hover">
                          <template v-if="item.is_choose == 1">
                            <v-btn v-if="check_moban.themes_id != item.themes_id" color="#fff" rounded class="tpl-btn" @click="check_moban = item">
                              {{ $t("选择模板") }}
                            </v-btn>
                            <v-btn v-else outlined color="#fff" rounded class="tpl-btn" @click="check_moban = ''">
                              {{ $t("取消选择") }}
                            </v-btn>
                          </template>
                          <p v-else class="tpl-locked">
                            {{ $t("需付费使用") }}（{{ tplPriceText(item) }}），{{ $t("可在模板市场购买") }}
                          </p>
                          <v-btn outlined color="#fff" rounded class="tpl-btn" @click.stop="previewTemplate(item)">
                            <v-icon size="14" class="mr-1">mdi-eye-outline</v-icon>
                            {{ $t("预览") }}
                          </v-btn>
                        </div>
                      </v-img>
                      <div class="tpl-check" v-if="check_moban.themes_id == item.themes_id">
                        <v-icon size="16" color="#fff">mdi-check</v-icon>
                      </div>
                      <!-- 收费标记：原来只有「免费/需付费」两种模糊状态，看不出多少钱 -->
                      <span class="tpl-price-tag" :class="{ 'is-free': !Number(item.price) }">
                        {{ tplPriceText(item) }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <div class="mt-3 tpl-pager">
                <v-pagination v-model="themesPage" :length="themesTotal" total-visible="5" color="#7331FF" circle @input="getThemesList()"></v-pagination>
              </div>
            </v-card>
            <div class="step-sticky-bar">
              <router-link to="/" class="step-action-btn">
                <v-icon size="16" class="mr-1">mdi-logout-variant</v-icon>
                {{ $t("离开") }}
              </router-link>
              <v-spacer />
              <span @click="tab = tab - 1" class="step-back-btn">
                <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                {{ $t("后退") }}
              </span>
              <v-btn v-if="check_moban != ''" color="#7331FF" dark rounded large class="ml-4" @click="next(2)">
                {{ $t("下一步") }}
                <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn v-else disabled rounded large class="ml-4">
                {{ $t("下一步") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="mx-auto box transition-fast-in-fast-out" style="padding: 32px 0" flat v-if="tab == 3">
        <div class="step-header">
          <div class="step-titles">
            <p class="step-title">{{ $t("完善店铺信息") }}</p>
            <p class="step-sub">{{ $t("填写店铺名称与域名，完成注册即可开店") }}</p>
          </div>
          <div class="step-num">
            <span class="step-current">3</span>
            <span class="step-total">/3</span>
          </div>
        </div>
        <div class="step-progress">
          <div class="step-progress-bar" style="width:100%"></div>
        </div>
            <div class="signup-form-card">
              <div class="signup-section">
                <div class="section-title">
                  <v-icon size="18" color="#7331FF" class="mr-2">mdi-storefront-outline</v-icon>
                  {{ $t("店铺信息") }}
                </div>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="signup-field">
                      <label class="field-label">{{ $t("店铺名称") }} <span class="red--text">*</span></label>
                      <p class="field-hint">{{ $t("创建一个简单好记的店铺名称") }}</p>
                      <input v-model="shopObj.name" class="field-input" :placeholder="$t('填写您的店铺名称')" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="signup-field">
                      <label class="field-label">{{ $t("店铺域名") }} <span class="red--text">*</span></label>
                      <p class="field-hint">{{ $t("设置简洁前缀，方便用户检索商店") }}</p>
                      <div class="domain-input">
                        <span class="domain-prefix">http://</span>
                        <input v-model="shopObj.path" @input="checkWeb()" class="domain-field" :placeholder="$t('字母或数字')" />
                        <span class="domain-suffix">.taoifydemo.com</span>
                      </div>
                      <p v-if="isshowweb == 'error' && shopObj.path != ''" class="field-error">
                        <v-icon size="14">mdi-alert-circle-outline</v-icon>{{ webmsg }}
                      </p>
                      <p v-if="isshowweb == 'success' && shopObj.path != ''" class="field-success">
                        <v-icon size="14">mdi-check-circle-outline</v-icon>{{ webmsg }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <template v-if="$store.state.USERINFO == null">
                <div class="signup-section">
                  <div class="section-title">
                    <v-icon size="18" color="#7331FF" class="mr-2">mdi-account-outline</v-icon>
                    {{ $t("个人信息") }}
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="signup-field">
                        <label class="field-label">{{ $t("电子邮件") }} <span class="red--text">*</span></label>
                        <input v-model="shopObj.email" @input="checkEmail()" class="field-input" :placeholder="$t('填写您的电子邮箱')" />
                        <p v-if="isshowemail == 'error' && shopObj.email != ''" class="field-error">
                          <v-icon size="14">mdi-alert-circle-outline</v-icon>{{ emailmsg }}
                        </p>
                        <p v-if="isshowemail == 'success' && shopObj.email != ''" class="field-success">
                          <v-icon size="14">mdi-check-circle-outline</v-icon>{{ emailmsg }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="signup-field">
                        <label class="field-label">{{ $t("店铺密码") }} <span class="red--text">*</span></label>
                        <input type="password" v-model="shopObj.pwd" class="field-input" :placeholder="$t('填写您的店铺密码')" />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="signup-field">
                        <label class="field-label">{{ $t("邮箱验证码") }} <span class="red--text">*</span></label>
                        <div class="code-row">
                          <input v-model="shopObj.code" class="field-input" :placeholder="$t('请输入邮箱验证码')" />
                          <v-btn color="#7331FF" dark rounded small class="code-btn" @click="getCode()" :loading="sendloading"
                            :disabled="!(isshowemail == 'success' && msg != '')">
                            {{ msg == null ? countNum + 's' : msg }}
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="signup-field">
                        <label class="field-label">{{ $t("电话号码") }} <span class="red--text">*</span></label>
                        <div class="phone-row">
                          <v-menu offset-y v-model="menu" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                              <v-card v-bind="attrs" v-on="on" class="country-select" flat>
                                {{ countryObj == "" ? $t("区号") : countryObj.country + " +" + countryObj.mobile_country_code }}
                                <v-icon size="16">mdi-chevron-down</v-icon>
                              </v-card>
                            </template>
                            <v-card class="country-dropdown" flat>
                              <v-card color="#F8F9FC" flat class="rounded-2 mb-2">
                                <input v-model="keyword" @input="inputCountry()" class="country-search" :placeholder="$t('搜索国家')" />
                              </v-card>
                              <div class="country-list">
                                <div v-for="(item, index) in countryList" :key="index" class="country-item"
                                  @click="(countryObj = item), (menu = false)">
                                  {{ item.country }} +{{ item.mobile_country_code }}
                                </div>
                              </div>
                            </v-card>
                          </v-menu>
                          <input v-model="shopObj.phone" @input="checkPhone()" class="field-input" :placeholder="$t('填写您的电话号码')" />
                        </div>
                        <p v-if="isshowphone == 'error' && shopObj.phone != ''" class="field-error">
                          <v-icon size="14">mdi-alert-circle-outline</v-icon>{{ phonemsg }}
                        </p>
                        <p v-if="isshowphone == 'success' && shopObj.phone != ''" class="field-success">
                          <v-icon size="14">mdi-check-circle-outline</v-icon>{{ phonemsg }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </template>

              <!-- 法律条款勾选区 -->
              <div class="legal-agree-box">
                <v-checkbox v-model="istongyi" hide-details color="#7331FF" class="legal-check"></v-checkbox>
                <div class="legal-text">
                  <p class="mb-1 legal-line">
                    {{ $t("我已阅读并同意以下法律文件：") }}
                  </p>
                  <div class="legal-links">
                    <a target="_blank" href="/consumer-agreement" class="legal-link">{{ $t("消费协议") }}</a>
                    <span class="legal-sep">·</span>
                    <a target="_blank" href="/terms-service" class="legal-link">{{ $t("服务条款") }}</a>
                    <span class="legal-sep">·</span>
                    <a target="_blank" href="/user-agreement" class="legal-link">{{ $t("用户使用协议") }}</a>
                    <span class="legal-sep">·</span>
                    <a target="_blank" href="/privacy-policy" class="legal-link">{{ $t("隐私政策") }}</a>
                  </div>
                  <p class="mb-0 legal-warn" v-if="!istongyi">
                    <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
                    {{ $t("请先阅读并勾选同意上述法律文件，才能开通店铺") }}
                  </p>
                </div>
              </div>
            </div>

            <div class="step-sticky-bar">
              <router-link to="/" class="step-action-btn">
                <v-icon size="16" class="mr-1">mdi-logout-variant</v-icon>
                {{ $t("离开") }}
              </router-link>
              <v-spacer />
              <span @click="tab = tab - 1" class="step-back-btn">
                <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                {{ $t("后退") }}
              </span>
              <template v-if="$store.state.USERINFO == null">
                <v-btn color="#7331FF" dark rounded large class="ml-4"
                  :disabled="!istongyi || submitting"
                  :loading="submitting" @click="chuangjian()">
                  {{ $t("创建") }}
                  <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <v-btn color="#7331FF" dark rounded large class="ml-4"
                  :disabled="!istongyi || submitting"
                  :loading="submitting" @click="addShop()">
                  {{ $t("开通") }}
                  <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
                </v-btn>
              </template>
            </div>
          </div>
            </div>
      </div>
      <v-card class="mx-auto box transition-fast-in-fast-out" style="padding: 156px 0; margin-top: 180px" flat
        v-if="tab == 5">
        <v-img width="288" class="mx-auto" src="@/assets/images/login/shengcheng.png"></v-img>
        <v-card width="70%" class="mx-auto mt-6" flat>
          <v-progress-linear v-model="knowledge" height="16" class="rounded-pill progress white--text">
            <strong>{{ Math.ceil(knowledge) }}%</strong>
          </v-progress-linear>
        </v-card>
      </v-card>
    </v-card>
    <v-dialog v-model="agreeDialog" persistent max-width="680" max-height="90vh">
      <v-card class="agree-dialog-card" style="border-radius:16px;overflow:hidden;">
        <div class="agree-head">
          <v-icon class="mr-2" color="#7331FF">mdi-file-document-outline</v-icon>
          <span>{{ $t('法律文件') }}</span>
          <v-btn icon x-small @click="agreeDialog = false" class="ml-auto">
            <v-icon size="18">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-tabs v-model="tabIndex" class="agree-tabs" grow>
          <v-tab>{{ $t('消费协议') }}</v-tab>
          <v-tab>{{ $t('服务条款') }}</v-tab>
          <v-tab>{{ $t('用户使用协议') }}</v-tab>
        </v-tabs>
        <div class="agree-body">
          <v-tabs-items v-model="tabIndex">
            <v-tab-item>
              <ConsumerAgreement />
            </v-tab-item>
            <v-tab-item>
              <TermsService />
            </v-tab-item>
            <v-tab-item>
              <UserAgreement />
            </v-tab-item>
          </v-tabs-items>
        </div>
        <div class="agree-foot">
          <v-btn color="#7331FF" dark rounded depressed @click="agreeDialog = false">
            <v-icon size="16" class="mr-1">mdi-check</v-icon>
            {{ $t('我已阅读并同意') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

  </v-app>
</template>
<script>
import ConsumerAgreement from '../article/ConsumerAgreement'
import TermsService from '../article/TermsService'
import UserAgreement from '../article/UserAgreement'
export default {
  components: {
    ConsumerAgreement,
    TermsService,
    UserAgreement
  },
  data() {
    return {
      menu: false,
      keyword: "",
      tab2Active: {
        name: this.$t("商城站"),
        msg: this.$t(
          "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业"
        )
      },
      tab2Arr: [
        {
          name: this.$t("商城站"),
          msg: this.$t(
            "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业"
          )
        },
        {
          name: this.$t("代购站"),
          msg: this.$t(
            "创建一个电子商务网站，帮您在线采购中国商品，系统化订单管理，促进销售并管理您的日常工作。"
          )
        }
      ],
      check_moban: "",
      knowledge: 0,
      timer: false,
      tab: 1,
      shopObj: {
        name: "",
        path: "",
        email: "",
        code: "",
        pwd: "",
        phone: "",
        third_web_domain: ""
      },
      istongyi: false,
      webmsg: this.$t("请填写有效的域名"),
      isshowweb: "error",
      emailmsg: this.$t("请填写正确的邮箱"),
      isshowemail: "error",
      phonemsg: this.$t("请填写有效的电话号码"),
      isshowphone: "error",
      countryList: [],
      cpuntryListOld: [],
      countryObj: "",
      msg: this.$t("点击发送验证码"),
      countNum: 60,
      sendloading: false,
      intervalBtn: "",
      themesList: [],
      themesPage: 1,//模版列表分页
      themesTotal: 1,//模版列表总页数
      themesTotalCount: 0,//筛选后的模板总数
      tplTags: [],//模板分类标签
      tplFilter: {
        keyword: "",
        themes_tag_id: "",
        start_price: "",
        end_price: ""
      },
      iscansendcode: true, //点击发送验证码开关 防止重复点击
      agreeDialog: true,//同意协议弹窗
      tabIndex: 0,//模板切换
      submitting: false, //防重复提交锁

    };
  },
  mounted() {
    // 代理归因：宣传站 /a/{code} 的 CTA 会带 ?a=代理码。
    // 用户可能进来后又翻了几页才注册，所以先存本地（30 天），
    // 提交时再取 —— 只靠路由参数会在这中间丢掉。
    var a = this.$route.query.a;
    if (a) {
      try {
        localStorage.setItem(
          "tao_agent",
          JSON.stringify({ code: String(a), at: Date.now() })
        );
      } catch (e) {}
    }
    this.getThemesList();
    this.getThemesTagList();
    this.getCountry();
  },
  computed: {
    // 当前有效的代理码（30 天内）
    agentCode() {
      var fromQuery = this.$route.query.a;
      if (fromQuery) return String(fromQuery);
      try {
        var v = JSON.parse(localStorage.getItem("tao_agent") || "null");
        if (v && v.code && Date.now() - v.at < 30 * 86400000) return v.code;
      } catch (e) {}
      return "";
    }
  },
  watch: {
    "$store.state.USERINFO"(val) { }
  },
  methods: {
    // 模板详情。注册流程里只有官方模板（themes_id），店主发布的走 custom_themes_id
    previewTemplate(item) {
      if (!item) return;
      if (item.custom_themes_id) {
        window.open('/template-detail?custom_themes_id=' + item.custom_themes_id, '_blank');
        return;
      }
      if (!item.themes_id) return;
      window.open('/template-detail?themes_id=' + item.themes_id, '_blank');
    },
    // 卡片价格：0 元显示「免费」，收费显示符号 + 金额
    tplPriceText(item) {
      if (!item) return "";
      var price = parseFloat(item.price || 0);
      if (!price) return this.$t("免费");
      return (item.symbol || "¥") + price;
    },
    inputCountry() {
      if (this.keyword == "") {
        this.countryList = this.countryListOld;
      } else {
        let list = [];
        let lowerKey = this.keyword.toLowerCase();
        for (let item of this.countryListOld) {
          let newVal = item.country + item.mobile_country_code;
          newVal = newVal.toLowerCase();

          if (newVal.includes(lowerKey)) {
            list.push(item);
          }
        }
        this.countryList = list;
      }
    },
    getCountry() {
      this.$api.shop.get_country_list({}).then(res => {
        if (res.status == 1) {
          this.countryList = res.data;
          this.countryListOld = res.data;
        } else {
          this.countryList = [];
          this.countryListOld = [];
        }
      });
    },
    // 倒计时
    countDown() {
      // 设置btn倒计时时显示的信息
      this.msg = null;
      this.iscansendcode = false;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 重置btn提示信息
          this.msg = this.$t("点击发送验证码");
          // 清除定时器
          this.iscansendcode = true;
          clearInterval(this.intervalBtn);
          // 更改btn状态
          // 重置倒计时状态
          this.countNum = 60;
        }
        // 倒计时
        this.countNum--;
      }, 1000);
    },
    getCode() {
      this.sendloading = true;
      if (this.iscansendcode) {
        this.$api.shop
          .send_code({ account: this.shopObj.email, event: "register" })
          .then(res => {
            this.sendloading = false;
            if (res.status == 1) {
              this.$Toast({ content: res.msg });
              this.countDown();
            } else {
              this.$Toast({ content: res.msg, type: "error" });
            }
          });
      }
    },
    getThemesList() {
      var params = {
        current_page: this.themesPage,
        page_number: 27,
        // 注册开店只列官方模板：店主发布的模板要购买/授权，
        // 在这个页面选中也用不了（测试反馈的「无法使用的模板」）
        only_official: 1
      };
      if (this.tplFilter.keyword) params.keyword = this.tplFilter.keyword;
      if (this.tplFilter.themes_tag_id) params.themes_tag_id = this.tplFilter.themes_tag_id;
      if (this.tplFilter.start_price !== "") params.start_price = this.tplFilter.start_price;
      if (this.tplFilter.end_price !== "") params.end_price = this.tplFilter.end_price;
      this.$api.template.list(params).then(res => {
        if (res.status == 1) {
          var records = res.data.records || [];
          this.themesList = records;
          this.themesTotalCount = parseInt(res.data.total) || 0;
          this.themesTotal = Math.max(1, Math.ceil(this.themesTotalCount / 27));
          // 当前选中的模板已经不在结果里（换了筛选条件）就重新指一个
          var stillThere = records.some(function (it) {
            return it.themes_id && it.themes_id == this.check_moban.themes_id;
          }, this);
          if (!this.check_moban.themes_id || !stillThere) {
            this.check_moban = records[8] || records[0] || "";
          }
        }
      });
    },
    getThemesTagList() {
      this.$api.template.tag_list().then(res => {
        if (res.status == 1) {
          this.tplTags = res.data || [];
        }
      });
    },
    pickTplTag(tag) {
      this.tplFilter.themes_tag_id = tag ? tag.themes_tag_id : "";
      this.themesPage = 1;
      this.getThemesList();
    },
    applyTplFilter() {
      // 最低价填得比最高价大就自动对调，否则后端必然返回空，看着像「筛选没生效」
      var sp = parseFloat(this.tplFilter.start_price);
      var ep = parseFloat(this.tplFilter.end_price);
      if (!isNaN(sp) && !isNaN(ep) && sp > ep) {
        this.tplFilter.start_price = ep;
        this.tplFilter.end_price = sp;
      }
      this.themesPage = 1;
      this.getThemesList();
    },
    resetTplFilter() {
      this.tplFilter = { keyword: "", themes_tag_id: "", start_price: "", end_price: "" };
      this.themesPage = 1;
      this.getThemesList();
    },
    checkWeb() {
      //const reg = "^[A-Za-z0-9]{4,50}$";
      const reg = "^(?!-|\\d)[a-z\\d-]{4,50}(?<!-)$";
      if (this.shopObj.path == "") {
        this.isshowweb = "error";
        this.webmsg = this.$t("请填写有效的域名");
        return false;
      }
      if (/[A-Z]/.test(this.shopObj.path)) {
        this.isshowweb = "error";
        this.webmsg = this.$t("不支持大写字母，请使用小写字母");
        return false;
      }
      if (!this.shopObj.path.match(reg)) {
        this.isshowweb = "error";
        this.webmsg = this.$t("商店地址要求：4-50个字符，由小写字母、数字和连接符（-）组成，不能以数字或连接符开头或结尾，且不能包含大写字母或空格。");
        return false;
      }
      this.$api.shop
        .check_web_domain({
          shop_web_domain: this.shopObj.path + ".taoifydemo.com"
        })
        .then(res => {
          this.webmsg = this.$t(res.msg);
          if (res.status == 1) {
            this.isshowweb = "success";
          } else {
            this.isshowweb = "error";
          }
        });
    },
    checkEmail() {
      if (this.shopObj.email == "") {
        this.emailmsg = this.$t("请填写正确的邮箱");
        return false;
      }
      this.$api.shop
        .check_account({ account: this.shopObj.email })
        .then(res => {
          this.emailmsg = res.msg;
          if (res.status == 1) {
            this.isshowemail = "success";
          } else {
            this.isshowemail = "error";
          }
        });
    },
    checkPhone() {
      if (this.shopObj.phone == "") {
        this.phonemsg = this.$t("请填写有效的电话号码");
        this.isshowphone = "error";
        return false;
      }
      // 面向全球：仅校验纯数字 + 7-15 位（ITU-T E.164 上限 15 位，7 位覆盖全球绝大多数正式手机号）
      if (!/^\d{7,15}$/.test(this.shopObj.phone)) {
        this.phonemsg = this.$t("电话号码需为7-15位数字");
        this.isshowphone = "error";
        return false;
      }
      this.phonemsg = this.$t("电话号码格式正确");
      this.isshowphone = "success";
    },
    chuangjian() {
      if (this.submitting) return; // 防重复提交
      if (this.shopObj.name == "") {
        this.$Toast({ content: this.$t("请填写店铺名称"), type: "error" });
        return;
      }
      if (this.isshowweb == "error") {
        this.$Toast({
          content: this.$t("请填写有效的域名"),
          type: "error"
        });
        return;
      }
      if (this.isshowemail == "error") {
        this.$Toast({
          content: this.$t("请填写有效的电子邮箱"),
          type: "error"
        });
        return;
      }
      if (this.shopObj.pwd == "") {
        this.$Toast({ content: this.$t("请填写店铺密码"), type: "error" });
        return;
      }
      if (this.shopObj.code == "") {
        this.$Toast({ content: this.$t("请填写邮箱验证码"), type: "error" });
        return;
      }
      if (this.shopObj.phone == "" || this.isshowphone == "error") {
        this.checkPhone();
        this.$Toast({
          content: this.phonemsg || this.$t("请填写有效的电话号码"),
          type: "error"
        });
        return;
      }
      if (this.countryObj == "") {
        this.$Toast({ content: this.$t("请选择区号"), type: "error" });
        return;
      }

      let param = {
        shop_name: this.shopObj.name,
        account: this.shopObj.email,
        password: this.shopObj.pwd,
        shop_web_domain: this.shopObj.path + ".taoifydemo.com",
        third_web_domain: this.shopObj.third_web_domain,
        themes_id: this.check_moban.themes_id,
        mobile_country_code: this.countryObj.mobile_country_code,
        mobile: this.shopObj.phone,
        business_country_code: this.countryObj.country_code,
        business_country: this.countryObj.country,
        captcha: this.shopObj.code,
        // 代理归因：后端 Shop::open_shop 读这个字段写 dp_shop.agent_id
        agent_code: this.agentCode
      };
      // console.log(param)
      // return
      this.submitting = true;
      this.$api.shop.open_shop(param).then(res => {
        this.submitting = false;
        if (res.status == 1) {
          this.istongyi = false;
          localStorage.setItem(
            "DROPSHOPINFO",
            JSON.stringify(res.data.shop_info)
          );
          localStorage.setItem("defaultShopid", res.data.shop_info.shop_id);
          localStorage.setItem("SHOPLIST", JSON.stringify(res.data.shop_infos));
          localStorage.setItem(
            "shop_web_domain",
            res.data.shop_info.shop_web_domain
          );
          this.$store.commit("setUSERINFO", res.data.user_info);
          let deflang_ = {};
          deflang_ = {
            logo: res.data.shop_info.lang_logo,
            lang_sign: res.data.shop_info.lang_sign,
            lang_id: res.data.shop_info.lang_id,
            name: res.data.shop_info.lang_name
          };
          localStorage.setItem("deflang", JSON.stringify(deflang_));
          //  this.getconfig();
          this.tab = 5;
          this.jindu();
        } else {
          this.submitting = false;
          this.$Toast({ content: res.msg, type: "error" });
        }
      }).catch(() => { this.submitting = false; });
    },
    //添加更多店铺
    addShop() {
      if (this.submitting) return; // 防重复提交
      if (this.shopObj.name == "") {
        this.$Toast({ content: this.$t("请填写店铺名称"), type: "error" });
        return;
      }
      if (this.isshowweb == "error") {
        this.$Toast({
          content: this.$t("请填写有效的店铺域名"),
          type: "error"
        });
        return;
      }

      let param = {
        shop_name: this.shopObj.name,
        shop_web_domain: this.shopObj.path + ".taoifydemo.com",
        themes_id: this.check_moban.themes_id,
        business_country_code: this.countryObj.country_code,
        business_country: this.countryObj.country
      };

      this.submitting = true;
      this.$api.shop.add(param).then(res => {
        this.submitting = false;
        if (res.status == 1) {
          this.istongyi = false;
          //  localStorage.setItem('DROPSHOPINFO',JSON.stringify(res.data))
          //  localStorage.setItem('defaultShopid',res.data.shop_id)
          localStorage.setItem(
            "DROPSHOPINFO",
            JSON.stringify(res.data.shop_info)
          );
          localStorage.setItem("defaultShopid", res.data.shop_info.shop_id);
          localStorage.setItem(
            "shop_web_domain",
            res.data.shop_info.shop_web_domain
          );
          localStorage.setItem("SHOPLIST", JSON.stringify(res.data.shop_infos));
          let deflang_ = {};
          deflang_ = {
            logo: res.data.shop_info.lang_logo,
            lang_sign: res.data.shop_info.lang_sign,
            lang_id: res.data.shop_info.lang_id,
            name: res.data.shop_info.lang_name
          };
          localStorage.setItem("deflang", JSON.stringify(deflang_));
          // this.getconfig();
          this.tab = 5;
          this.jindu();
        } else if (res.status == -4) {
          this.submitting = false;
          this.$Toast({ content: res.msg, type: "error" });
          location.href = "./manger_admin/sign-up";
        } else {
          this.submitting = false;
          this.$Toast({ content: res.msg, type: "error" });
        }
      }).catch(() => { this.submitting = false; });
    },
    getconfig() {
      this.$api.public.getconfig().then(res => {
        if (res.status == 1) {
          localStorage.setItem("dropshoplocalconfig", JSON.stringify(res.data));
        }
      });
    },
    next(num) {
      if (num == 2 && this.check_moban == "") {
        this.$Toast({ content: this.$t("请选择店铺模板"), type: "error" });
        return false;
      }
      if (num == 3 && this.check_moban == "") {
        this.$Toast({ content: this.$t("请选择店铺模板"), type: "error" });
        return false;
      }
      this.tab = this.tab + 1;
    },
    jindu() {
      this.knowledge = 0;
      this.timer = setInterval(() => {
        if (this.knowledge == 100) {
          this.shopObj.path;
          if (this.$store.state.USERINFO != null) {
            this.shopObj.email = this.$store.state.USERINFO.email;
          }
          let obj = {
            shop: this.shopObj,
            modie: this.check_moban
          };

          //   obj.shop.path = obj.shop.path + ".taoifydemo.com";
          localStorage.setItem("shop", JSON.stringify(obj));
          this.$router.push({
            path: "/success"
          });
          return false;
        }
        this.knowledge = this.knowledge + 5;
      }, 300);
      if (this.knowledge == 100) {
        clearInterval(this.timer);
      }
    },
    toPayTemplate(item) {
      this.toPayObj.themes_id = item.themes_id;
      this.toPayObj.dialog = true;
    }
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.intervalBtn);
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 1000px;
}

@media (max-width: 1000px) {
  .box {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .box {
    width: 95%;
  }
}

.overflow-y {
  overflow-y: auto;
  overflow-x: hidden;
}

.agree-dialog-card {
  overflow: hidden;
}

.agree-head {
  display: flex;
  align-items: center;
  padding: 16px 20px 8px;
  font-size: 16px;
  font-weight: 700;
  color: #1F2A3D;
}

.agree-tabs {
  background: #F8F7FE;
  margin: 0 16px;
  border-radius: 8px;

  .v-tab {
    text-transform: none;
    font-size: 13px;
    font-weight: 600;
    min-height: 36px;
  }
}

.agree-body {
  max-height: 50vh;
  overflow-y: auto;
  padding: 16px 20px;
  font-size: 13px;
  line-height: 1.7;
  color: #3D4757;
}

.agree-foot {
  display: flex;
  justify-content: center;
  padding: 12px 20px 18px;
  border-top: 1px solid #EEF1F5;
}

.ipt-href {
  border: solid 1px #e5e5e5;
  height: 45px;
  background-color: #f7f7f7;
  border-radius: 4px;
}

.ipt-href-left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: solid 1px #e5e5e5;
  height: 43px;
  background-color: #ffffff;
}

.ipt-href-right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: solid 1px #e5e5e5;
  height: 43px;
  background-color: #ffffff;
}

.legal-agree-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 20px;
  padding: 14px 16px;
  background: #F8F7FE;
  border: 1px solid #E8E2FF;
  border-radius: 10px;

  .legal-check {
    margin: 0;
    flex-shrink: 0;
  }

  .legal-text {
    flex: 1;
  }

  .legal-line {
    font-size: 13px;
    color: #3D4757;
    font-weight: 600;
  }

  .legal-links {
    margin-bottom: 6px;
  }

  .legal-link {
    font-size: 13px;
    color: #7331FF;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  .legal-sep {
    margin: 0 6px;
    color: #B4BDC9;
  }

  .legal-warn {
    font-size: 12px;
    color: #FF5252;
    display: flex;
    align-items: center;
  }
}

.step-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 12px;

  .step-title {
    font-size: 24px;
    font-weight: 700;
    color: #0F3460;
    margin-bottom: 4px;
  }

  .step-sub {
    font-size: 13px;
    color: #8A96A8;
    margin-bottom: 0;
  }

  .step-num {
    display: flex;
    align-items: baseline;
    gap: 2px;

    .step-current {
      font-size: 32px;
      font-weight: 800;
      color: #7331FF;
    }

    .step-total {
      font-size: 18px;
      font-weight: 600;
      color: #C3CAD6;
    }
  }
}

.step-progress {
  width: 100%;
  height: 6px;
  background: #EDEFF5;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 20px;

  .step-progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #7331FF, #9B5CFF);
    border-radius: 6px;
    transition: width 0.3s ease;
  }
}

/* ---------- 模板筛选条 ---------- */
.tpl-filter {
  margin: 16px 0 6px;
  padding: 12px 14px;
  background: #FBFAFF;
  border: 1px solid #EEF1F5;
  border-radius: 12px;

  &__cats {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 8px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    padding-top: 10px;
    border-top: 1px dashed #E7EAF0;
  }

  &__go {
    text-transform: none;
    font-weight: 600;
    min-width: 84px;
  }

  &__reset {
    font-size: 13px;
    color: #8A96A8;
    cursor: pointer;
    padding: 0 4px;
    white-space: nowrap;

    &:hover {
      color: #7331FF;
    }
  }

  &__count {
    margin-left: auto;
    font-size: 13px;
    color: #9AA5B5;
    white-space: nowrap;
  }
}

.tpl-cat {
  flex: 0 0 auto;
  padding: 5px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #E7EAF0;
  color: #4A5568;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    border-color: #C9B6FF;
    color: #7331FF;
  }

  &.active {
    background: #7331FF;
    border-color: #7331FF;
    color: #fff;
    font-weight: 600;
  }
}

.tpl-search {
  flex: 1 1 200px;
  min-width: 160px;
}

.tpl-price {
  display: flex;
  align-items: center;
  gap: 6px;

  &__input {
    width: 96px;
  }

  &__line {
    color: #C3CAD6;
  }
}

@media (max-width: 600px) {
  .tpl-filter__row {
    gap: 8px;
  }

  .tpl-filter__count {
    margin-left: 0;
    width: 100%;
  }

  .tpl-search {
    flex: 1 1 100%;
  }
}

.template-picker {
  background: transparent;

  .tpl-card {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid transparent;
    transition: border-color 0.2s, transform 0.2s;

    &:hover {
      transform: translateY(-2px);
    }

    &.tpl-selected {
      border-color: #7331FF;
      box-shadow: 0 4px 16px rgba(115, 49, 255, 0.2);
    }
  }

  .tpl-img {
    border-radius: 12px;
  }

  .tpl-hover {
    position: absolute;
    inset: 0;
    background: rgba(15, 20, 40, 0.78);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s;

    &:hover { opacity: 1; }
  }

  .tpl-btn {
    text-transform: none;
    font-size: 13px;
    font-weight: 600;
    min-width: 120px;
  }

  .tpl-locked {
    color: #FF8A8A;
    font-size: 12px;
    margin: 0;
  }

  .tpl-preview {
    color: #fff;
    font-size: 12px;
    text-decoration: underline;
  }

  .tpl-check {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #7331FF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 价格徽标：免费/收费一眼可辨 */
  .tpl-price-tag {
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 2px 10px;
    border-radius: 999px;
    background: rgba(15, 20, 40, 0.72);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    pointer-events: none;

    &.is-free {
      background: rgba(24, 160, 88, 0.92);
    }
  }

  /* 触屏设备没有 hover：操作按钮永远显示在底部，否则手机上根本点不到「预览」 */
  @media (hover: none) {
    .tpl-hover {
      opacity: 1;
      background: linear-gradient(to top, rgba(15, 20, 40, 0.85) 0%, rgba(15, 20, 40, 0) 55%);
      justify-content: flex-end;
      padding-bottom: 14px;
    }
  }
}

.tpl-pager {
  display: flex;
  justify-content: center;
}

.signup-form-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(15, 52, 96, 0.06);
}

.signup-field {
  margin-bottom: 20px;

  .field-label {
    font-size: 14px;
    font-weight: 600;
    color: #1F2A3D;
    margin-bottom: 6px;
    display: block;
  }

  .field-hint {
    font-size: 12px;
    color: #8A96A8;
    margin-bottom: 8px;
  }

  .field-input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #E5E9F0;
    border-radius: 10px;
    font-size: 14px;
    color: #1F2A3D;
    background: #F8F9FC;
    outline: none;
    transition: border-color 0.2s, background 0.2s;

    &:focus {
      border-color: #7331FF;
      background: #fff;
    }
  }

  .field-error {
    font-size: 12px;
    color: #FF5252;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .field-success {
    font-size: 12px;
    color: #22C55E;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.signup-section {
  margin-bottom: 28px;

  .section-title {
    font-size: 18px;
    font-weight: 700;
    color: #0F3460;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEF1F5;
    display: flex;
    align-items: center;
  }
}

.domain-input {
  display: flex;
  align-items: center;
  height: 44px;
  border: 1px solid #E5E9F0;
  border-radius: 10px;
  background: #F8F9FC;
  overflow: hidden;

  .domain-prefix, .domain-suffix {
    padding: 0 12px;
    font-size: 13px;
    color: #8A96A8;
    background: #F0F2F7;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .domain-field {
    flex: 1;
    border: none;
    outline: none;
    height: 100%;
    padding: 0 12px;
    font-size: 14px;
    background: transparent;
    color: #1F2A3D;
  }
}

.code-row {
  display: flex;
  gap: 8px;

  .field-input { flex: 1; }

  .code-btn {
    min-width: 110px;
    text-transform: none;
    font-size: 13px;
  }
}

.phone-row {
  display: flex;
  gap: 8px;

  .field-input { flex: 1; }

  .country-select {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #E5E9F0;
    border-radius: 10px;
    background: #F8F9FC;
    font-size: 13px;
    color: #3D4757;
    cursor: pointer;
    white-space: nowrap;
  }
}

.country-dropdown {
  background: #F5F6F9;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 8px 30px rgba(15, 52, 96, 0.12);
  width: 260px;

  .country-search {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    height: 40px;
    padding: 0 12px;
    font-size: 13px;
  }

  .country-list {
    max-height: 200px;
    overflow-y: auto;
  }

  .country-item {
    padding: 8px 10px;
    font-size: 13px;
    border-radius: 6px;
    cursor: pointer;

    &:hover { background: #F5F3FF; color: #7331FF; }
  }
}

.step-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 44px;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 500;
  color: #8A96A8;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.2s;

  &:hover {
    color: #5A6678;
    background: #F3F4F8;
  }
}

.step-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 0 22px;
  font-size: 13px;
  font-weight: 600;
  color: #3D4757;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #D8DDE6;
  background: #fff;
  transition: all 0.2s;

  &:hover {
    border-color: #B8C0CC;
    background: #F5F6F9;
  }
}

.step-sticky-bar {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #F8F9FC;
  border: 1px solid #E8EAF0;
  border-radius: 16px;
  margin-top: 16px;

  .v-btn {
    height: 44px !important;
    min-width: 120px;
    font-size: 13px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    border-radius: 10px !important;

    &.v-btn--disabled {
      background: #E8EAF0 !important;
      color: #9AA3B2 !important;
      opacity: 1 !important;

      .v-icon {
        color: #9AA3B2 !important;
      }
    }
  }
}
</style>